<template>
  <div v-if="active" class="loader-wrapper">
    <div class="loader">
      <div></div>
    </div>
    <!-- KSK037/KSK115: kiosk-only loading spinner; hidden outside .app-kiosk-mode. -->
    <div
      class="loader-ksk-card"
      role="status"
      aria-live="polite"
      :aria-label="$t('kiosk.common.pleaseWait')"
    >
      <span class="loader-ksk-spinner" aria-hidden="true"></span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Loader',
  props: {
    active: Boolean,
    text: String
  }
}
</script>

<style scoped>
.loader-wrapper {
  text-align: center;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999 !important;
}

.loader {
  display: inline-block;
  width: 80px;
  height: 80px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 9999;
}

.loader div {
  width: 60px;
  height: 60px;
  border: 11px dotted black;
  border-radius: 50%;
  display: inline-block;
  position: relative;
  box-sizing: border-box;
  animation: rotation 1.5s linear infinite;
}

@keyframes rotation {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
} 

.loader-ksk-card {
  display: none;
}

/* KSK037 — P20 kiosk full-screen loading. The overlay blocks taps at once
   (as before); only its appearance fades in after 150ms so fast API calls
   do not flash the scrim.
   KSK115 — softer look: a light veil instead of the dark scrim, a small
   frosted disc and a gradient "comet" ring spinner, no text. */
.app-kiosk-mode .loader-wrapper {
  background: rgba(255, 255, 255, 0.35);
  animation: ksk-loader-in 240ms ease-out 150ms both;
}

.app-kiosk-mode .loader {
  display: none;
}

.app-kiosk-mode .loader-ksk-card {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 120px;
  height: 120px;
  border-radius: 50%;
  background: color-mix(in srgb, var(--ksk-surface) 86%, transparent);
  backdrop-filter: blur(16px) saturate(1.4);
  -webkit-backdrop-filter: blur(16px) saturate(1.4);
  border: 1px solid rgba(255, 255, 255, 0.6);
  box-shadow: 0 12px 40px rgba(20, 26, 20, 0.12), 0 2px 8px rgba(20, 26, 20, 0.06);
  animation: ksk-loader-card-in 280ms cubic-bezier(0.2, 0.8, 0.2, 1) 150ms both;
}

/* Comet ring: a conic gradient fading from transparent to the brand colour,
   masked to a 6px ring, with a round dot capping the bright end. */
.app-kiosk-mode .loader-ksk-spinner {
  position: relative;
  width: 64px;
  height: 64px;
  border-radius: 50%;
  background: conic-gradient(from 0deg, transparent 0deg, var(--ksk-primary) 300deg, transparent 300deg);
  -webkit-mask: radial-gradient(farthest-side, transparent calc(100% - 6px), #000 calc(100% - 6px));
  mask: radial-gradient(farthest-side, transparent calc(100% - 6px), #000 calc(100% - 6px));
  animation: rotation 0.9s linear infinite;
}

.app-kiosk-mode .loader-ksk-spinner::after {
  content: "";
  position: absolute;
  top: 0;
  left: 50%;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: var(--ksk-primary);
  transform: translateX(-50%) rotate(300deg);
  transform-origin: 50% 32px;
}

@keyframes ksk-loader-in {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes ksk-loader-card-in {
  from {
    opacity: 0;
    transform: scale(0.9);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

@media (prefers-reduced-motion: reduce) {
  .app-kiosk-mode .loader-ksk-spinner {
    animation-duration: 2.4s;
  }
}
</style>
